import { ButtonGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useConcurso } from '../../../providers/ConcursoProvider';
import {
  getReporteEstadoConcurso,
  getReporteRequisitosDeclarados,
} from '../Gestion/TramitarConcursos/restPostulacionesPuesto';
import { postAvanzarEtapaConcurso } from './restAccionesConcurso';

const AccionesEvaluacionAntecedentesCC = () => {
  const { idLlamadoConcurso, etapaLlamadoConcurso } = useConcurso();
  const { idEtapaLlamadoConcurso } = etapaLlamadoConcurso;
  const dispatch = useDispatch();

  const FlexDiv = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: auto;
    margin: 18px auto;
  `;
  return (
    <FlexDiv>
      <ButtonGroup>
        {/* REPORTES */}
        <DropdownButton as={ButtonGroup} id="dropdown-basic-button" title="Reportes">
          <Dropdown.Item
            onClick={() =>
              dispatch(getReporteEstadoConcurso({ idLlamadoConcurso, idEtapaLlamadoConcurso }))
            }>
            Postulantes
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => dispatch(getReporteRequisitosDeclarados({ idLlamadoConcurso }))}>
            Requisitos declarados
          </Dropdown.Item>
        </DropdownButton>

        <DropdownButton as={ButtonGroup} id="dropdown-basic-button" title="Finalizar">
          <Dropdown.Item
            onClick={() => {
              if (
                window.confirm(
                  'Se avanzará a la siguiente etapa el concurso Nro: ' +
                    idLlamadoConcurso +
                    ' ¿Está seguro?',
                )
              )
                dispatch(postAvanzarEtapaConcurso({ idLlamadoConcurso }));
            }}>
            Avanzar Etapa
          </Dropdown.Item>
        </DropdownButton>
      </ButtonGroup>
    </FlexDiv>
  );
};

export default AccionesEvaluacionAntecedentesCC;
